import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';

export const createOsmBaseLayer = ({ title = 'OpenStreetMap', visible = true, ...rest } = {}) =>
    new TileLayer({
        title,
        visible,
        source: new OSM(),
        ...rest,
    });
